import { NotifyHelper } from "../../../helpers/toast";
import { eCauHoiActionsObj } from "../../action-types/cau-hoi/ICauHoiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const cauHoiActions = {
  ...generateActions(eCauHoiActionsObj, "CAU_HOI"),
  ...generateActionForKey(eCauHoiActionsObj, "CAU_HOI", "SAVE_SUCCESS", () => {
    NotifyHelper.Success("Đã cập nhật");
  }),
  ...generateActionForKey(
    eCauHoiActionsObj,
    "CAU_HOI",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(
    eCauHoiActionsObj,
    "CAU_HOI",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    },
  ),
  ...generateActionForKey(
    eCauHoiActionsObj,
    "CAU_HOI",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Success(m ?? "Thất bại");
    },
  ),
  ...generateActionForKey(
    eCauHoiActionsObj,
    "CAU_HOI",
    "DELETES_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    },
  ),
  ...generateActionForKey(
    eCauHoiActionsObj,
    "CAU_HOI",
    "DELETES_ERROR",
    (m: string) => {
      NotifyHelper.Error(m ?? "Thất bại");
    },
  ),
  ...generateActionForKey(
    eCauHoiActionsObj,
    "CAU_HOI",
    "IMPORT_WORD_SUCCESS",
    () => {
      NotifyHelper.Success("Import thành công");
    },
  ),
  ...generateActionForKey(
    eCauHoiActionsObj,
    "CAU_HOI",
    "PROGRESS_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    },
  ),
  ...generateActionForKey(
    eCauHoiActionsObj,
    "CAU_HOI",
    "CHANGE_SU_DUNG_SUCCESS",
    () => {
      NotifyHelper.Success("Đã chuyển thành công");
    },
  ),
  ...generateActionForKey(
    eCauHoiActionsObj,
    "CAU_HOI",
    "CHANGE_SU_DUNG_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(eCauHoiActionsObj, "CAU_HOI", "PROGRESS_ERRR", () => {
    NotifyHelper.Error("Thất bại");
  }),
};
